import React from "react";

import { IPanelProps, Panel } from "core/decorators/Panel";
import InstitutionFilterComponent from "./InstitutionFilterComponent";
import labelProvider from "./InstitutionsFilter.labels";

@Panel({
	id: "institution-filter",
	pageParams: true,
	labelProvider
})
class InstitutionsFilterPanel extends React.PureComponent<IPanelProps<{}>, {}> {

	public constructor(props: IPanelProps<{}>) {
		super(props);
	}

	public render() {
		const { pageParams, actions } = this.props;
		const institution = pageParams["institution"];
	
		return (
			<InstitutionFilterComponent 
				defaultInst={institution}
				setInstitution={(inst,first)=>{
						if(!inst){
							return;
						}
						if(first)
							actions.replacePageParams({key:'institution',value:inst});
						else
							actions.pushPageParams({key:'institution',value:inst});
					}
				}
			/>	
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/institutions/InstitutionsFilter.panel.tsx